import {
  CampaignMessageType,
  CampaignObjective,
  CampaignStatus
} from './enums/campaign';

export function designStepIsRequired(objective: string | null): boolean {
  return objective !== CampaignObjective.SimpleSms;
}

export function designStepIsCompleted(templateId: string | null): boolean {
  return !!templateId;
}

export function designStepStillNeedsToBeCompleted(
  designStepIsRequired: boolean,
  templateId: string
): boolean {
  return designStepIsRequired && !templateId;
}

export const DefaultCampaignObjective = CampaignObjective.Engagement;

export const CampaignObjectiveDisplayValues: Record<
  string,
  Record<string, string>
> = {
  [CampaignObjective.Engagement]: {
    displayName: 'Landing page',
    iconName: 'mdi-cellphone'
  },
  [CampaignObjective.LinkOnly]: {
    displayName: 'Link only',
    iconName: 'mdi-link-variant'
  },
  [CampaignObjective.SimpleSms]: {
    displayName: 'SMS/MMS',
    iconName: 'mdi-message-text'
  }
  // [CampaignObjective.Growth]: {
  //   displayName: 'Growth',
  //   iconName: 'mdi-sprout'
  // },
};

export const MobizCampaignObjectiveDisplayValues: Record<
  string,
  { displayName: string; iconName: string }
> = {
  [CampaignObjective.Engagement]: {
    displayName: 'Landing page',
    iconName: 'mdi-cellphone'
  },
  [CampaignObjective.SimpleSms]: {
    displayName: 'Other',
    iconName: 'mdi-gesture-tap'
  }
};

export const MobizCampaignMessageTypeDisplayValues: Record<
  string,
  { displayName: string; iconName: string }
> = {
  [CampaignMessageType.Sms]: {
    displayName: 'SMS',
    iconName: 'mdi-message-text'
  },
  [CampaignMessageType.Mms]: {
    displayName: 'MMS',
    iconName: 'mdi-image'
  }
};

export const OwnSenderCampaignObjectiveDisplayValues: Record<
  string,
  Record<string, string>
> = {
  [CampaignObjective.LinkOnly]: {
    displayName: 'Link only',
    iconName: 'mdi-link-variant'
  }
};

export const CampaignStateFilterDisplayValues: Record<
  string,
  Record<string, string>
> = {
  [CampaignStatus.Draft]: {
    displayName: 'Draft',
    iconName: 'mdi-file-document-edit'
  },
  [CampaignStatus.Scheduled]: {
    displayName: 'Scheduled',
    iconName: 'mdi-calendar-clock'
  },
  [CampaignStatus.Sent]: {
    displayName: 'Sent',
    iconName: 'mdi-send-lock'
  }
};

export const CampaignStateLabelDisplayValues: Record<
  string,
  Record<string, string>
> = {
  [CampaignStatus.Draft]: {
    displayName: 'Draft',
    color: 'smart-faded-red',
    textColor: 'black'
  },
  [CampaignStatus.Scheduled]: {
    displayName: 'Scheduled',
    color: 'smart-blue',
    textColor: 'white'
  },
  [CampaignStatus.Sent]: {
    displayName: 'Sent',
    color: 'smart-green',
    textColor: 'black'
  },
  [CampaignStatus.Sending]: {
    displayName: 'Sending',
    color: 'smart-light-blue-2',
    textColor: 'black'
  },
  [CampaignStatus.Queuing]: {
    displayName: 'Queuing',
    color: 'smart-light-green',
    textColor: 'black'
  },
  [CampaignStatus.Autoresume]: {
    displayName: 'Auto-resume',
    color: 'smart-orange',
    textColor: 'black'
  },
  [CampaignStatus.Failed]: {
    displayName: 'Failed',
    color: 'smart-red',
    textColor: 'white'
  },
  [CampaignStatus.Canceled]: {
    displayName: 'Canceled',
    color: 'smart-dark-grey-2',
    textColor: 'white'
  }
};
